import {isProdEnvironment} from '/util/env.util';

export const ENABLE_STORYBOOK = !isProdEnvironment();
